import './locales/register'
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const Create = lazy(() => import('./components/Create'))
const Update = lazy(() => import('./components/Update'))

const RolesModule: RouteObject = {
    path: 'roles',
    children: [
        {
            path: '',
            children: [
                { path: '', element: <List /> },
                { path: 'new', element: <Create /> },
                {
                    path: ':roleName',
                    children: [{ path: '', element: <Update /> }],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default RolesModule
